@if (loading) {
  <div class="loader"></div>
}
@if (!loading) {
  <div class="left-modal">
    <div class="close" (click)="close()"></div>
    @if (!loading) {
      <div class="modal-container">
        <h1>{{'Change quantity' | translate}}</h1>
        <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
          <div class="row">
            <div class="L-12 M-12 S-12 columns">
              <div class="L-6 M-6 S-8 columns centered">
                <label>{{'Quantity' | translate}}</label>
                <input class="centered" numeric type="text" name="quantity" [(ngModel)]="formData.quantity" placeholder="{{'Insert' | translate}}" required>
              </div>
              <div class="L-6 M-6 S-8 columns centered">
                <input type="checkbox" name="apply" [(ngModel)]="formData.apply">
                <p class="checkbox uppercase">{{'Apply change to following weeks' | translate}}</p>
              </div>
            </div>
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <input name="sumbit" type="submit" value="{{'Save' | translate}}" [disabled]="form.invalid">
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
          </div>
        </form>
      </div>
    }
  </div>
}